import { useTranslation } from "react-i18next";
import NewBtn from "./NewBtn";
import { FC } from "react";

interface CreateBtnProps {
    handleOnClick: (event?: any) => void;
    adding?: boolean;
}

const CreateBtn: FC<CreateBtnProps> = ({
    handleOnClick,
    adding = true
}) => {
    const { t } = useTranslation()
    return (
        <NewBtn
            handleOnClick={handleOnClick}
            hoverText={adding ? t("toolTip.addNewItem") : t("toolTip.cancelNewItem")}
            adding={adding}
        />
    );
};

export default CreateBtn